import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { getFieldData, getFormatedNumber } from "../../../Services/appService";
import { getCurrentUser } from "../../store/auth";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../../store/candidate";
import { useDispatch, useSelector } from "react-redux";
import TimerPopup from "../../../Components/TimerPopup";
import AppMessages from "../../../Components/AppMessages";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import { OverlayTrigger, Popover } from "react-bootstrap";

export default function OnboardingStatus() {

    const usrType = localStorage.getItem("userType");
    const [entityType, setEntityType] = useState("");
    const [appTasklist, setAppTasklist] = useState([]);
    const [appSubmitStatus, setAppSubmitStatus] = useState(false);
    const [timerShowHide, setTimerShowHide] = useState(false);
    const [msgShowHide, setMsgShowHide] = useState(false);
    const [wfId, setWfId] = useState(0);
    const [currentApp, setCurrentApp] = useState("");

    const candidateAppsSelector = useSelector(getCandidateApps);
    const appTasksSelector = useSelector(getAppTasks);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const navigate = useNavigate();

    const route = [
        { name: "Task Management", url: "" },
        { name: "Onboarding", url: "" },
    ];
    const route1 = [
        { name: "Contract Management", url: "" },
        { name: "Onboarding", url: "" },
    ];

    let appType = "Onboarding";
    if (usrType === "candidate")
        appType = "Onboarding";

    let count = entityType !== "C2C Basis" ? "6" : "5";

    if (usrType !== "candidate")
        count = "5";


    useEffect(() => {
        dispatch(setCurrentPageTitle(`STEP-${count} : ${appType}`));
        dispatch(setCurrentRoute(usrType === "candidate" ? route : route1))
    }, [])

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
            dispatch(loadCandidateApps(usrId))
    }, []);

    useEffect(() => {
        if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                setWfId(wf.oldWorkflowId);
                let usrId = currentUser.id;
                if (currentUser.linkUser)
                    usrId = currentUser.linkUser;
                if (appTasksSelector.length === 0 && currentUser?.id > 0)
                    dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0
                && (x.wfPhase === "Review" || x.wfPhase === "Approved" || x.wfPhase === "Rejected"));
            let firstAppTasks = [];
            if (filterTasks.length > 0) {
                firstAppTasks = [filterTasks[filterTasks.length - 1]];
                setAppTasklist(firstAppTasks);
                setAppSubmitStatus(filterTasks[0].appSubmit);
            }
        }
    }, [appTasksSelector]);

    const handleViewAppSummary = (item, type) => {
        navigate("/ApplicationSummary", { state: { task: item, viewType: type } });
    }

    const handleCurrentTask = () => {
        // const { data: workflowTask } = await http.get(
        //     config.GetWorkflowTask + wiid
        //   );
        //   if (workflowTask.formId > 0) {
        //     if (workflowTask.formType === "CF") {
        //       this.props.history.push({
        //         pathname: "/" + workflowTask.formName,
        //         state: { workflowTask },
        //       });
        //     } else {
        //       this.props.history.push({
        //         pathname: "/DynamicForm",
        //         state: { workflowTask },
        //       });
        //     }
        //   }
    }

    const handleTimerModalShowHide = () => {
        setTimerShowHide(!timerShowHide);
    };

    const handleMsgShowHide = (app) => {
        setMsgShowHide(!msgShowHide);
        setCurrentApp(app);
    };

    function formatCustomDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const suffix = ["th", "st", "nd", "rd"][(day % 10 > 3 || [11, 12, 13].includes(day)) ? 0 : day % 10];

        return date.toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true
        }).replace(/\b\d{1,2}\b/, day + suffix);
    }

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h4">Notification</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <button className="btn btn-sm btn-link">Notification</button>
            </OverlayTrigger>
        );
    };


    return <React.Fragment>

        <div className="col-md-12  mt-2 form-group">
            <div className="card shadow-none border">
                <div className="card-header p-3">
                    <span className="h3">Check Onbording Status</span>
                </div>
                <div className="card-body p-3">
                    <div className="table-responsive border border-top-0">
                        <table className="table align-items-center table-flush table-hover table-striped">
                            <thead className="thead-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Date & Time<br />Submitted</th>
                                    <th>{appType} Form</th>
                                    <th>Reviewer Assigned</th>
                                    <th>Reviewer Re-Assigned</th>
                                    <th>Status</th>
                                    <th>Messages</th>
                                    {/* {
                                        usrType !== "candidate" &&
                                        <th>Alerts</th>
                                    } */}
                                </tr>
                            </thead>
                            <tbody>
                                {appTasklist.map((item, key) =>
                                    <tr>
                                        <td>{item.ciid}</td>
                                        <td>
                                            <Moment format="MMM Do YYYY">
                                                {item.startDateTime}
                                            </Moment>
                                            <br />
                                            <Moment format="h:mm a">
                                                {item.startDateTime}
                                            </Moment>
                                        </td>
                                        <td>

                                            <button
                                                onClick={() => handleViewAppSummary(item, "view")}
                                                className="btn btn-link p-0"
                                            >
                                                View
                                            </button>
                                            <br />
                                            <button
                                                onClick={() => handleViewAppSummary(item, "edit")}
                                                className="btn btn-link p-0"
                                            >
                                                Edit/Update
                                            </button>
                                        </td>
                                        <td>
                                            {item.reassignById > 0 ? <>
                                                {item.reassignByName?.toUpperCase()}
                                                <br />
                                                {item.reassignByRole}
                                                {item.reassignByRegistrationType !== "WP" &&
                                                    item.reassignByRegistrationType !== "PP" &&
                                                    item.reassignByRegistrationType}
                                                <br />
                                                {item.reassignByEmail}
                                                <br />
                                                {getFormatedNumber(item.reassignByContact)}
                                            </> : <>
                                                {item.performerId !== parseInt(currentUser.id) && <>
                                                    {item.performer?.toUpperCase()}
                                                    <br />
                                                    {item.role}
                                                    {item.partner}
                                                    {item.registrationType !== "WP" &&
                                                        item.registrationType !== "PP" &&
                                                        item.registrationType}
                                                    <br />
                                                    {item.email}
                                                    <br />
                                                    {getFormatedNumber(item.contact)}
                                                </>}
                                            </>}
                                        </td>
                                        <td>
                                            {item.reassignById > 0 && item.performerId !== parseInt(currentUser.id) && <>
                                                {item.performer?.toUpperCase()}
                                                <br />
                                                {item.role}
                                                {item.partner}
                                                {item.registrationType !== "WP" &&
                                                    item.registrationType !== "PP" &&
                                                    item.registrationType}
                                                <br />
                                                {item.email}
                                                <br />
                                                {getFormatedNumber(item.contact)}
                                                <br />
                                                {formatCustomDate(item.reassignDateTime)}
                                            </>}
                                        </td>
                                        <td style={{ whiteSpace: "pre-wrap" }}>
                                            {item.performerId === parseInt(currentUser.id) ?
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={() => handleCurrentTask(item.wiid)}
                                                >
                                                    {item.wfPhase}
                                                </button> : <>{item.wfPhase === "Approved" && <i
                                                    className="fa fa-check text-success"
                                                    style={{ fontSize: "15px" }}
                                                    aria-hidden="true"
                                                ></i>} {item.wfPhase}</>}
                                            <br />
                                            {usrType !== "candidate" && getPopover(getFieldData(item.stateData, "contractdocuments", "Notification_Notes"))}
                                        </td>
                                        <td>
                                            {item.taskDoneStatus !== 0 && item.wfPhase !== "Application" && (
                                                <button
                                                    className="btn btn-link btn-sm p-0"
                                                    onClick={() => handleMsgShowHide(item)
                                                    }
                                                >
                                                    View
                                                    <span
                                                        className="badge badge-pill badge-danger position-absolute mt--1 ml-0"
                                                    >
                                                        {item.unreadMessage}
                                                    </span>
                                                </button>
                                            )}
                                        </td>
                                        {/* <td>
                                            {
                                                usrType !== "candidate" &&
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={handleTimerModalShowHide}
                                                >
                                                    View
                                                </button>
                                            }

                                        </td> */}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        {timerShowHide && <TimerPopup
            timerShowHide={timerShowHide}
            handleTimerModalShowHide={handleTimerModalShowHide}
        ></TimerPopup>}
        {msgShowHide &&
            <AppMessages
                msgShowHide={msgShowHide}
                handleMsgShowHide={handleMsgShowHide}
                currentApp={currentApp}
                workflowId={wfId}
            ></AppMessages>}
    </React.Fragment>
}